<a
    [routerLink]="[item().link]"
    [ariaLabel]="item().ariaLabel | translate"
    class="group aspect-square flex flex-col rounded items-center justify-center bg-[var(--colorGrey)] hover:ring-2 hover:ring-inset hover:ring-[rgb(var(--ui-2))] hover:bg-opacity-80 text-[var(--color-text-active)] hover:text-[rgb(var(--ui-2))] no-underline hover:no-underline cursor-pointer"
>
    <div class="flex flex-col items-center justify-center gap-2">
        <sh-icon
            class="text-[24px] leading-none text-[rgb(var(--ui-1))] group-hover:text-[rgb(var(--ui-2))]"
            [icon]="item().icon"
            size="s"
            aria-hidden="true"
        />
        <span class="font-shBreeHeadline">{{ item().label | translate }}</span>
    </div>
</a>
